/* eslint-disable jsx-a11y/alt-text */
import {
    Box,
    Breadcrumbs,
    Button,
    Chip,
    Divider,
    IconButton,
    Paper,
    Tooltip,
    Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef, GridPinnedColumnFields } from "@mui/x-data-grid";
import { getCompanyProfileApi } from "../Services/OrgRepo";
import { ThreeDot } from "react-loading-indicators";
import oligasIcn from "../../assets/icons/oligas.png";
import evAutoIcn from "../../assets/icons/automotive.png";
import power from "../../assets/icons/power.png";
import industry from "../../assets/icons/industry.png";
import aerospace from "../../assets/icons/aerospace.png";
import defaultlogo from "../../assets/icons/noimg.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import {
    formatCurrencyValue,
    generateCompanyLogo,
    generateOrganisationLogo,
    generatProfilePicUrl,
    getProfilePic
} from "../../Utils/Constant";
import { DataGridPro } from "@mui/x-data-grid-pro";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EuroIcon from "@mui/icons-material/Euro";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

const isHighValueRfq = (row) => {
    const { currency, totalOrderValue } = row;

    return (
        (currency === "INR" && totalOrderValue >= 5000000) ||
        (currency === "EUR" && totalOrderValue >= 50000) ||
        (currency === "USD" && totalOrderValue >= 50000)
    );
};

const columnsRfq: GridColDef<AssociatedCompanyRFQ>[] = [
    {
        field: "rfqId",
        headerName: "CORFQ ID",
        width: 150,
        disableColumnMenu: true
    },

    {
        field: "rfqName",
        headerName: "CORFQ Name",
        width: 200,
        disableColumnMenu: true,
        cellClassName: (params) => {
            return isHighValueRfq(params?.row) ? "rfq-high-value-cell" : "";
        },
        renderCell: (params) => {
            const highValue = isHighValueRfq(params?.row);

            return (
                <>
                    {highValue && (
                        <>
                            <div className="highlightChip">
                                High value{" "}
                                <TrendingUpIcon sx={{ fontSize: "1rem" }} />
                            </div>
                        </>
                    )}
                    <Box
                        sx={{
                            textDecoration: "none",
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignItems: "center"
                        }}
                    >
                        {/* {logoUrl && (
            <img
              src={logoUrl}
              alt={""}
              width={24}
              height={24}
              style={{ borderRadius: "50%" }}
            />
          )} */}

                        <Typography variant="body2">{params.value}</Typography>
                    </Box>
                </>
            );
        }
    },
    {
        field: "rfqStartDate",
        headerName: "CORFQ Start Date",
        width: 180,
        disableColumnMenu: true
    },
    {
        field: "rfqEndDate",
        headerName: "CORFQ End Date",
        width: 180,
        disableColumnMenu: true
    },
    {
        field: "totalOrderValue",
        headerName: "Total Order Value",
        width: 180,
        disableColumnMenu: true,
        renderCell: (params) => {
            const value = params.value;
            const currency = params?.row?.currency;
            const formattedValue = formatCurrencyValue(value, currency);
            return (
                <>
                    <div style={{ display: "block" }}>
                        <Typography
                            variant="body2"
                            display="flex"
                            alignItems="center"
                        >
                            {getCurrencyIcon(params?.row?.currency)}
                            <span style={{ paddingLeft: "5px" }}>
                                {formattedValue}
                            </span>
                            {/* title={params?.row?.pricetype} */}
                            <Tooltip title={params?.row?.priceType}>
                                <IconButton>
                                    <InfoOutlinedIcon
                                        style={{ fontSize: "16px" }}
                                    />
                                </IconButton>
                            </Tooltip>
                        </Typography>
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            display="block"
                        >
                            {params?.row?.currency}
                        </Typography>
                    </div>
                </>
            );
        }
    },
    {
        field: "keyAccountManager",
        headerName: "Key Account Manager",
        width: 180,
        disableColumnMenu: true,
        //generatProfilePicUrl
        renderCell: (params) => {
            const name = params.value || "";
            return (
                <Grid container spacing={2} alignItems="center" width="100%">
                    <Grid size={{ xs: 2, md: 2 }}>
                        <img
                            src={
                                generatProfilePicUrl(
                                    params.row.keyAccountManagerID,
                                    params.row.keyAccountManagerProfilePath,
                                    "Profile_Picture"
                                ) || defaultlogo
                            }
                            alt="KAM"
                            width={24}
                            height={24}
                            style={{ marginRight: "5px", borderRadius: "50%" }}
                        />
                    </Grid>
                    <Grid size={{ xs: 10, md: 10 }}>
                        <Typography variant="body2" className="">
                            {name}
                        </Typography>
                    </Grid>
                </Grid>
            );
        }
    },
    {
        field: "department",
        headerName: "Department",
        width: 180,
        disableColumnMenu: true,
        renderCell: (params) => {
            return (
                <Chip
                    label={params.value}
                    color="default"
                    variant="outlined"
                    size="small"
                />
            );
        }
    },
    {
        field: "status",
        headerName: "CORFQ Status",
        width: 200,
        disableColumnMenu: true,
        cellClassName: () => "first-pinned-right",
        headerClassName: "first-pinned-right",
        renderCell: (params) => {
            const status = params?.row?.status || "-"; // Show '-' if status is missing
            let color:
                | "default"
                | "info"
                | "success"
                | "error"
                | "warning"
                | "primary"
                | "secondary" = "info"; // Default color
            if (status !== "-") {
                // if (
                //   sourcingManagerHead() ||
                //   qualityManagerHead() ||
                //   NPDManagerHead() ||
                //   productionManagerHead()
                // ) {
                switch (status) {
                    case "Approved":
                        color = "success";
                        break;
                    case "Rejected":
                        color = "error";
                        break;
                    case "Partially Approved":
                        color = "warning";
                        break;
                    //     default:
                    //       color = "info";
                    //   }
                    // } else if (accountManagerHead() || accountManager()) {
                    //   switch (status) {
                    case "Approved":
                        color = "success";
                        break;
                    case "Rejected":
                        color = "error";
                        break;
                    case "Approvers Review Pending":
                        color = "default";
                        break;
                    case "KAM Head Review Pending":
                        color = "warning";
                        break;
                    default:
                        color = "default";
                }
                // }
            }
            return status === "-" ? (
                "-"
            ) : (
                <Chip
                    label={
                        status === "Approved" ? "Approved by KAM Head" : status
                    }
                    color={color}
                    variant="outlined"
                    size="small"
                    sx={
                        status === "Approvers Review Pending"
                            ? {
                                  borderColor: "#FFB400",
                                  color: "#FFB400",
                                  backgroundColor: " #f8b71417!important"
                              }
                            : {}
                    }
                />
            );
        }
    }
];

interface CompanyData {
    About: About;
    Contact_Details: ContactDetails;
    Associated_Company_RFQs: AssociatedCompanyRFQ[];
}

interface About {
    address: string;
    keyAccountManager: string;
    industryType: string;
    locationType: string;
    gstApplicable: string;
    gstNumber: string;
    parentOrganisation: string;
    lastUpdateOn: string;
    companyName: string;
    companyID: string;
    companyLogo: string;
    organisationLogo: string;
    organisationID: number;
    keyAccountManagerID: string;
}

interface ContactDetails {
    primaryContact: ContactPerson;
    secondaryContact: ContactPerson;
}

interface ContactPerson {
    primaryPocName?: string;
    primaryPocEmail?: string;
    primaryContactNumber?: string;
    secondaryPocName?: string;
    secondaryPocEmail?: string;
    secondaryContactNumber?: string;
}

interface AssociatedCompanyRFQ {
    rfqId: string;
    rfqName: string;
    totalOrderValue: any;
    totalCoPoValue: number;
    rfqStartDate: string;
    rfqEndDate: string;
    status: string;
    companyImg: string;
    companyRecID: string;
    keyAccountManager: string;
    keyAccountManagerID: string;
    keyAccountManagerProfilePath: string;
    currency: string;
    priceType: string;
}
const getCurrencyIcon = (currency) => {
    switch (currency) {
        case "INR":
            return <CurrencyRupeeIcon sx={{ fontSize: "0.875rem" }} />;
        case "USD":
            return <AttachMoneyIcon sx={{ fontSize: "0.875rem" }} />;
        case "EUR":
            return <EuroIcon sx={{ fontSize: "0.875rem" }} />;
        default:
            return null;
    }
};

export const CompanyProfilePage = () => {
    const location = useLocation();
    // const { companyRecId, compDetails } = location.state || {};
    const storedData = JSON.parse(
        localStorage.getItem("CompanyProfilePage") || "null"
    );
    const { companyRecId, compDetails } = location.state || storedData || {};

    const [companyProfileDetails, setCompanyProfileDetails] =
        useState<CompanyData>(null);

    const [isLoading, setIsLoading] = useState(false);
    // const { getProfilePic } = useContext(ProfileContext);

    const [pinnedColumns, setPinnedColumns] =
        React.useState<GridPinnedColumnFields>({
            left: ["rfqId", "rfqName", "Partner_Name"],
            right: ["status"]
        });
    const handlePinnedColumnsChange = React.useCallback(
        (updatedPinnedColumns: GridPinnedColumnFields) => {
            setPinnedColumns(updatedPinnedColumns);
        },
        []
    );

    const [totalOrderInINR, setTotalOrderInINR] = useState(0);
    const [totalCoPoInINR, setTotalCoPoInINR] = useState(0);

    const fetchCompanyProfileDetails = async () => {
        setIsLoading(true);
        try {
            const response = await getCompanyProfileApi(companyRecId);
            setIsLoading(false);
            if (response?.status && response?.data?.length > 0) {
                const CompanyData = response?.data[0];
                setCompanyProfileDetails(CompanyData); // Set first element from API response
                // ✅ Extract RFQ data
                const rfqs = CompanyData?.Associated_Company_RFQs || [];
                // ✅ Conversion rates (update as needed)
                const conversionRates = {
                    USD: 88,
                    EUR: 103,
                    INR: 1
                };

                // ✅ Calculate total in INR
                const totalInINR = rfqs.reduce((sum, rfq) => {
                    const currency = rfq.currency || "INR";
                    const rate = conversionRates[currency] || 1;
                    const totalOrder = parseFloat(rfq.totalOrderValue) || 0;
                    return sum + totalOrder * rate;
                }, 0);

                const totalCoPoInINR = rfqs.reduce((sum, rfq) => {
                    const currency = rfq.currency || "INR";
                    const rate = conversionRates[currency] || 1;
                    const totalOrder = parseFloat(rfq.totalCoPoValue) || 0;
                    return sum + totalOrder * rate;
                }, 0);

                console.log("✅ Total Order Value (in INR):", totalInINR);
                // optional: store in state for UI display
                setTotalOrderInINR(totalInINR);
                setTotalCoPoInINR(totalCoPoInINR);
            } else {
                setCompanyProfileDetails(null);
            }
        } catch (error) {
            setIsLoading(false);
            setCompanyProfileDetails(null);
        }
    };

    useEffect(() => {
        fetchCompanyProfileDetails();
    }, [companyRecId]);

    const industryIcons = {
        "Oil & Gas": oligasIcn,
        "Power & Transmission": power,
        "EV/Automotive": evAutoIcn,
        "Industrial Products": industry,
        "Aerospace & Defence": aerospace
    };

    const companyUrl = (id, filepath) => {
        return generateCompanyLogo(id, filepath);
    };

    const orgUrl = (id, filepath) => {
        if (filepath) {
            return generateOrganisationLogo(id, filepath);
        } else {
            return defaultlogo;
        }
    };

    const logoPath = companyProfileDetails?.About?.companyLogo;
    const logoSrc =
        logoPath && logoPath !== "N/A"
            ? companyUrl(companyRecId, logoPath)
            : defaultlogo;

    // const from = location.state?.from;
    const from = location.state?.from || storedData?.from;

    const fromPageLabelMap: Record<string, string> = {
        CompanyRfq: "Company RFQ",
        CURFQAssignedToMe: "Assigned CORFQs",
        FRfqList: "Feasible CORFQs",
        OrgRepo: "Organisation Repository / Company"
    };

    let readableLabel = fromPageLabelMap[from] || from;

    if (from === "CompanyRfq") {
        readableLabel = "In Review";
    }

    return isLoading ? (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="50vh"
        >
            <ThreeDot color="#1976d2" size="medium" text="" textColor="" />
        </Box>
    ) : companyProfileDetails ? (
        <>
            {location?.pathname === "/layout/OrgProfilePage" && (
                <Breadcrumbs
                    aria-label="breadcrumb"
                    sx={{ marginBottom: "10px" }}
                >
                    {/* {(sourcingManager() || sourcingManagerHead()) && (
            <Typography sx={{ fontSize: "14px" }}>
              Sourcing Management
            </Typography>
          )}

          {(accountManager() || accountManagerHead()) && (
            <Typography sx={{ fontSize: "14px" }}>
              Account Management
            </Typography>
          )} */}
                    <Link
                        to="/layout/Dashboard"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Home
                    </Link>
                    <Typography sx={{ fontSize: "14px" }}>
                        <Link
                            to="/layout/OrgRepo"
                            style={{
                                color: "#0070ba",
                                fontSize: "14px",
                                textDecoration: "none"
                            }}
                        >
                            Organisation Repository
                        </Link>
                    </Typography>
                    <Typography
                        style={{ color: "#00000099", fontSize: "14px" }}
                    >
                        {companyProfileDetails?.About?.companyName}
                    </Typography>
                </Breadcrumbs>
            )}

            {location.pathname === "/layout/CompanyProfilePage" && (
                <Breadcrumbs
                    aria-label="breadcrumb"
                    sx={{ marginBottom: "10px" }}
                >
                    <Typography sx={{ fontSize: "14px" }}>
                        <Link
                            to="/layout/Dashboard"
                            style={{
                                color: "#0070BA",
                                fontSize: "14px",
                                textDecoration: "none"
                            }}
                        >
                            Home
                        </Link>
                    </Typography>
                    <Typography sx={{ fontSize: "14px" }}>
                        <Link
                            to={`/layout/${from}`}
                            style={{
                                color: "#0070ba",
                                fontSize: "14px",
                                textDecoration: "none"
                            }}
                        >
                            {readableLabel}
                        </Link>
                    </Typography>
                    <Typography
                        style={{
                            color: "#00000099",
                            textDecoration: "none",
                            fontSize: "14px"
                        }}
                    >
                        {companyProfileDetails?.About?.companyName}
                    </Typography>
                </Breadcrumbs>
            )}

            <Box
                mb={2}
                sx={{ display: "flex", justifyContent: "space-between" }}
            >
                <div style={{ display: "flex" }}>
                    <div>
                        <img
                            src={logoSrc}
                            width={60}
                            height={60}
                            style={{ marginRight: "5px", borderRadius: "50%" }}
                        />
                    </div>
                    <div style={{ marginLeft: "10px" }}>
                        <Typography variant="h5" mb={1}>
                            {companyProfileDetails?.About?.companyName}
                        </Typography>
                        <Box
                            sx={{
                                display: "inline-flex"
                            }}
                        >
                            <Typography variant="body2" color="text.secondary">
                                {companyProfileDetails?.About?.companyID}
                            </Typography>
                            <Divider
                                orientation="vertical"
                                sx={{ margin: "0 10px" }}
                                variant="middle"
                                flexItem
                            />
                            {/* <Chip
                label={"Active"}
                color="success"
                variant="outlined"
                size="small"
                sx={{ padding: "0 4px", marginRight: "5px" }}
              />
              <Divider
                orientation="vertical"
                sx={{ margin: "0 10px" }}
                variant="middle"
                flexItem
              /> */}
                            <Typography variant="body2" color="text.secondary">
                                Last updated on:{" "}
                                {companyProfileDetails?.About?.lastUpdateOn}
                            </Typography>
                        </Box>
                    </div>
                </div>
                {/* <div>
          {accountManagerHead() && (
            <Button variant="outlined" color="error">
              Deactivate
            </Button>
          )}
        </div> */}
            </Box>
            <Grid container spacing={2}>
                <Grid size={5}>
                    <Paper
                        elevation={0}
                        style={{ padding: "15px 15px", minHeight: "330px" }}
                    >
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, md: 12 }}>
                                <Typography variant="h6" fontWeight="bold">
                                    About
                                </Typography>
                                <Typography variant="body2" my={1}></Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    mb={1}
                                >
                                    Key Account Manager
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid size={{ xs: 2, md: 2 }}>
                                        <img
                                            src=""
                                            alt="KAM"
                                            width={30}
                                            height={30}
                                            style={{ borderRadius: "50%" }}
                                            ref={(img) => {
                                                if (
                                                    img &&
                                                    companyProfileDetails?.About
                                                        ?.keyAccountManagerID
                                                ) {
                                                    getProfilePic(
                                                        companyProfileDetails
                                                            .About
                                                            .keyAccountManagerID
                                                    ).then((url) => {
                                                        img.src = url || "-";
                                                    });
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 10, md: 10 }}>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                paddingLeft: "5px"
                                            }}
                                        >
                                            {companyProfileDetails?.About
                                                ?.keyAccountManager || "-"}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }} mb={1}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Industry Type
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }}>
                                <Chip
                                    variant="filled"
                                    size="small"
                                    label={
                                        <span
                                            style={{
                                                display: "flex",
                                                alignItems: "center"
                                            }}
                                        >
                                            {industryIcons[
                                                companyProfileDetails?.About
                                                    ?.industryType
                                            ] && (
                                                <img
                                                    src={`${industryIcons[companyProfileDetails?.About?.industryType]}`}
                                                    alt={
                                                        companyProfileDetails
                                                            ?.About
                                                            ?.industryType
                                                    }
                                                    style={{
                                                        width: 15,
                                                        height: 15,
                                                        marginRight: "5px"
                                                    }}
                                                />
                                            )}
                                            {companyProfileDetails?.About
                                                ?.industryType || "-"}
                                        </span>
                                    }
                                />
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }} mb={1}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Address
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }}>
                                <Typography
                                    variant="body2"
                                    display="flex"
                                    alignItems="center"
                                >
                                    {companyProfileDetails?.About?.address ||
                                        "-"}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    mb={1}
                                >
                                    Presence
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }}>
                                <Chip
                                    size="small"
                                    variant="outlined"
                                    color={
                                        companyProfileDetails?.About
                                            ?.locationType === "International"
                                            ? "secondary"
                                            : "primary"
                                    }
                                    label={
                                        companyProfileDetails?.About
                                            ?.locationType || "-"
                                    }
                                />
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    mb={1}
                                >
                                    Total CORFQ Value (in INR)
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }}>
                                <Typography
                                    variant="body2"
                                    display="flex"
                                    alignItems="center"
                                >
                                    ₹{" "}
                                    {new Intl.NumberFormat("en-IN").format(
                                        totalOrderInINR
                                    )}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    mb={1}
                                >
                                    Total COPO Value (in INR)
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }}>
                                <Typography
                                    variant="body2"
                                    display="flex"
                                    alignItems="center"
                                >
                                    ₹{" "}
                                    {new Intl.NumberFormat("en-IN").format(
                                        totalCoPoInINR
                                    )}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }} mb={1}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    GST Applicable
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }}>
                                <Typography variant="body2">
                                    {" "}
                                    {companyProfileDetails?.About
                                        ?.gstApplicable || "-"}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }} mb={1}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    GST Number
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }}>
                                <Typography variant="body2">
                                    {" "}
                                    {companyProfileDetails?.About?.gstNumber ||
                                        "-"}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }} mb={1}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Parent Organisation
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 6, md: 6 }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    <img
                                        src={orgUrl(
                                            companyProfileDetails?.About
                                                ?.organisationID,
                                            companyProfileDetails?.About
                                                ?.organisationLogo
                                        )}
                                        width={24}
                                        height={24}
                                        style={{
                                            borderRadius: "50%",
                                            marginRight: "5px"
                                        }}
                                    />
                                    {companyProfileDetails?.About
                                        ?.parentOrganisation || "-"}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid size={7}>
                    <Paper elevation={0} style={{ padding: "15px" }}>
                        <Typography variant="h6" fontWeight="bold" mb={1}>
                            Contact Details
                        </Typography>

                        <Grid container spacing={2} mt={2}>
                            <Grid size={12}>
                                <Typography
                                    variant="body2"
                                    sx={{ fontWeight: "600" }}
                                >
                                    Primary Contact Details
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    First Name
                                </Typography>
                                <Typography variant="body2">
                                    {companyProfileDetails?.Contact_Details
                                        ?.primaryContact?.primaryPocName || "-"}
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 12, md: 5 }}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Email
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ wordBreak: "break-all" }}
                                >
                                    {companyProfileDetails?.Contact_Details
                                        ?.primaryContact?.primaryPocEmail ||
                                        "-"}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 3 }}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Contact no
                                </Typography>
                                <Typography variant="body2">
                                    {companyProfileDetails?.Contact_Details
                                        ?.primaryContact
                                        ?.primaryContactNumber || "-"}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} mt={3}>
                            <Grid size={12}>
                                <Typography
                                    variant="body2"
                                    sx={{ fontWeight: "600" }}
                                >
                                    Secondary Contact Details
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    First Name
                                </Typography>
                                <Typography variant="body2">
                                    {companyProfileDetails?.Contact_Details
                                        ?.secondaryContact?.secondaryPocName ||
                                        "-"}
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 12, md: 5 }}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Email
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ wordBreak: "break-all" }}
                                >
                                    {companyProfileDetails?.Contact_Details
                                        ?.secondaryContact?.secondaryPocEmail ||
                                        "-"}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 3 }}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Contact no
                                </Typography>
                                <Typography variant="body2">
                                    {companyProfileDetails?.Contact_Details
                                        ?.secondaryContact
                                        ?.secondaryContactNumber || "-"}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
            <Grid container spacing={2} mt={2}>
                <Grid size={12}>
                    <Paper elevation={0} style={{ padding: "10px" }}>
                        <Typography variant="h6" fontWeight="bold" mb={1}>
                            Associated CORFQs
                        </Typography>
                        {companyProfileDetails?.Associated_Company_RFQs
                            ?.length > 0 ? (
                            <DataGridPro
                                rows={
                                    companyProfileDetails?.Associated_Company_RFQs
                                }
                                columns={columnsRfq}
                                getRowHeight={() => "auto"}
                                pinnedColumns={pinnedColumns}
                                onPinnedColumnsChange={
                                    handlePinnedColumnsChange
                                }
                                initialState={{
                                    pagination: {
                                        paginationModel: { pageSize: 4 }
                                    }
                                }}
                                getRowId={(row) => row.rfqId}
                                sx={{
                                    width: "100%",
                                    "& .MuiDataGrid-columnHeaderTitleContainer":
                                        {
                                            "& .MuiDataGrid-sortIcon": {
                                                opacity: "1 !important",
                                                visibility: "visible !important"
                                            }
                                        },
                                    "& .MuiDataGrid-cell": {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    "& .MuiDataGrid-scrollbarFiller--pinnedRight":
                                        {
                                            backgroundColor: "#F4F4F4!important"
                                        }
                                }}
                            />
                        ) : (
                            <Typography
                                variant="h6"
                                textAlign="center"
                                mt={2}
                                color="text.secondary"
                            >
                                CORFQs associated with this company will appear
                                here
                            </Typography>
                        )}
                    </Paper>
                </Grid>
            </Grid>
        </>
    ) : (
        <Typography variant="h6" textAlign="center" mt={2}>
            No data found
        </Typography>
    );
};
